<template>
  <v-alert
    v-if="protectionLimit"
    density="compact"
    :icon="alertConfig.icon"
    :color="alertConfig.backgroundColor"
    class="mb-4 py-1 px-2"
    :class="alertConfig.textColor"
  >
    <span
      v-html="
        $t('devices.protectionLimitBanner.message', {
          used: protectionLimit.used,
          total: protectionLimit.total,
          remaining: protectionLimit.remaining,
        })
      "
    />
    <span v-if="protectionLimit.unlicensedCount > 0">
      {{
        $t(
          "devices.protectionLimitBanner.unlicensed",
          { count: protectionLimit.unlicensedCount },
          protectionLimit.unlicensedCount
        )
      }}
    </span>
  </v-alert>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from "vue";
import { type ProtectionLimit, ProtectionLimitStatus } from "@/constants/devices";

export default defineComponent({
  props: {
    protectionLimit: {
      type: Object as PropType<ProtectionLimit | null>,
      default: null,
    },
  },
  setup(props) {
    const alertConfig = computed(() => {
      if (props.protectionLimit?.status === ProtectionLimitStatus.EXCEEDED) {
        return {
          icon: "icon-warning-xs",
          backgroundColor: "yellow-faint",
          textColor: "text-yellow-base",
        };
      }
      return {
        icon: "icon-success-xs",
        backgroundColor: "green-faint",
        textColor: "text-green-dark",
      };
    });

    return {
      alertConfig,
    };
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-alert__prepend) {
  .icon-success-xs::before {
    color: rgb(var(--v-theme-green-dark));
  }
  .icon-warning-xs::before {
    color: rgb(var(--v-theme-yellow-base));
  }
  margin-right: 5px !important;
}
</style>
